export const FONT_WEIGHT = {
  normal: 300,
  medium: 500,
  bold: 600,
} as const;
